
// src/widgets/WidgetContainer.tsx
import { WidgetConfig } from "./widgetConfig";

export class WidgetContainer {
    public element: HTMLElement;
    private titleElement: HTMLElement;
    private contentElement: HTMLElement;
    public currentWidgetContent: HTMLElement | null = null;

    constructor() {
        this.element = document.createElement('div');
        this.element.className = 'widget-container';

        this.titleElement = document.createElement('div');
        this.titleElement.className = 'widget-title';

        this.contentElement = document.createElement('div');

        this.element.appendChild(this.titleElement);
        this.element.appendChild(this.contentElement);
    }

    public async setWidget(widgetConfig: WidgetConfig, gameState?: any) {
        this.titleElement.textContent = widgetConfig.title;

        let data;
        if (widgetConfig.fetchData) {
            data = await widgetConfig.fetchData(gameState);
        }

        const widgetContent = widgetConfig.component(data || gameState);
        this.contentElement.innerHTML = ''; // Clear previous content
        this.contentElement.appendChild(widgetContent);
        this.currentWidgetContent = widgetContent;
    }

    public show() {
        this.element.style.display = 'block';
        // Trigger reflow to ensure the display change is applied before adding the class
        void this.element.offsetWidth;
        this.element.classList.remove('fade-out');
        this.element.classList.add('fade-in');
    }

    public hide(): Promise<void> {
        return new Promise(resolve => {
            this.element.classList.remove('fade-in');
            this.element.classList.add('fade-out');
            // Match the transition duration in Widgets.css
            setTimeout(() => {
                this.element.style.display = 'none';
                resolve();
            }, 500);
        });
    }
}
